/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createResultSet } from '../../factoriesNumber.js';
export var ResultSetDependencies = {
  createResultSet
};